import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "frame-41" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "frame-42" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "logo-off",
    alt: "Logo off",
    src: "https://c.animaapp.com/nNxA75tB/img/logo-off-1-1.svg"
  }),
  /*#__PURE__*/_createElementVNode("p", { class: "text-wrapper-24" }, " Florisuite est la plateforme tout-en-un conçue pour les fleuristes, offrant des outils puissants pour une gestion optimisée. ")
], -1)
const _hoisted_3 = { class: "frame-43" }
const _hoisted_4 = { class: "frame-44" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "text-wrapper-25" }, "Produit", -1)
const _hoisted_6 = { class: "frame-45" }
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"frame-44\"><div class=\"text-wrapper-25\">Entreprise</div><div class=\"frame-46\"><div class=\"text-wrapper-26\">À propos</div><div class=\"text-wrapper-27\">Carrières</div><div class=\"text-wrapper-27\">Blog</div></div></div>", 1)
const _hoisted_8 = { class: "frame-44" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "text-wrapper-25" }, "Support", -1)
const _hoisted_10 = { class: "frame-47" }
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<div class=\"frame-44\"><div class=\"text-wrapper-25\">Suivez-nous</div><div class=\"frame-48\"><a class=\"button-3\" href=\"https://www.facebook.com/\" target=\"_blank\" rel=\"noopener noreferrer\" aria-label=\"Facebook\"><div class=\"text\"></div><img class=\"img-3\" alt=\"Facebook\" src=\"https://c.animaapp.com/nNxA75tB/img/facebook-1.svg\"></a><a class=\"button-3\" href=\"https://www.instagram.com/\" target=\"_blank\" rel=\"noopener noreferrer\" aria-label=\"Instagram\"><div class=\"text\"></div><img class=\"img-3\" alt=\"Instagram\" src=\"https://c.animaapp.com/nNxA75tB/img/instagram-1.svg\"></a><a class=\"button-4\" href=\"https://www.linkedin.com/\" target=\"_blank\" rel=\"noopener noreferrer\" aria-label=\"LinkedIn\"><div class=\"linked-in\"><img class=\"group\" alt=\"Group\" src=\"https://c.animaapp.com/nNxA75tB/img/group-1@2x.png\"><div class=\"text-wrapper-28\">link</div></div><div class=\"text-2\"></div></a></div></div>", 1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "container-5" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "line",
    alt: "Line",
    src: "https://c.animaapp.com/nNxA75tB/img/line-1.svg"
  }),
  /*#__PURE__*/_createElementVNode("p", { class: "text-wrapper-29" }, " © 2025 Florisuite. Tous droits réservés. ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['footer-wrapper', _ctx.className])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_RouterLink, {
              class: "text-wrapper-26 footer-link",
              to: "/fonctionnalites"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Fonctionnalités ")
              ]),
              _: 1
            }),
            _createVNode(_component_RouterLink, {
              class: "text-wrapper-27 footer-link",
              to: "/tarifs"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Tarifs ")
              ]),
              _: 1
            }),
            _createVNode(_component_RouterLink, {
              class: "text-wrapper-27 footer-link",
              to: "/inscription"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Démo ")
              ]),
              _: 1
            }),
            _createVNode(_component_RouterLink, {
              class: "text-wrapper-27 footer-link",
              to: "/inscription"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Voir la démo… ")
              ]),
              _: 1
            })
          ])
        ]),
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_RouterLink, {
              class: "text-wrapper-26 footer-link",
              to: "/tarifs#faq"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" FAQ ")
              ]),
              _: 1
            }),
            _createVNode(_component_RouterLink, {
              class: "text-wrapper-27 footer-link",
              to: "/contact"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Aide et contact ")
              ]),
              _: 1
            })
          ])
        ]),
        _hoisted_11
      ])
    ]),
    _hoisted_12
  ], 2))
}